var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 17V2c0-.55.196-1.02.587-1.413A1.926 1.926 0 012.5 0h12c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412v5.075a3.416 3.416 0 00-.5-.063 10.015 10.015 0 00-1 0c-.167.009-.333.03-.5.063V2h-12v10h7.075a3.416 3.416 0 00-.063.5 10.015 10.015 0 000 1c.009.167.03.333.063.5H3.5l-3 3zm4-11h8V4h-8v2zm0 4h5V8h-5v2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.549 8l1.383 1.417-1.595 1.581 4.175.05-.024 2-4.175-.05 1.555 1.619L14.451 16l-3.95-4.049 4.048-3.95z"
  })));
}
export default SvgRequestFeedback;